function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import EditAgreementModal from "../components/EditAgreementModal/EditAgreementModal";
import { useOverlayContext, useStoreActions } from "../contexts";
import { handleRequest } from "../infra/utils";
import { jsx as _jsx } from "react/jsx-runtime";
const loader = 'getRelationship';
export function useOpenEditAgreementModal() {
  const {
    api,
    logBI
  } = useStoreActions();
  const overlayContext = useOverlayContext();
  async function getRelationship(options) {
    if (options.relationship) {
      return options.relationship;
    } else {
      overlayContext.startLoader(loader);
      const relationship = await handleRequest(api.relationship.get(options.relationshipId, {
        // We need paymentMethod info for the edit-agreement modal.
        resolvePaymentMethod: true
      }));
      overlayContext.stopLoader(loader);
      return relationship.data;
    }
  }
  return async options => {
    const relationship = await getRelationship(options);
    if (relationship) {
      logBI(11000);
      return overlayContext.showModal({
        content: props => /*#__PURE__*/_jsx(EditAgreementModal, _objectSpread(_objectSpread({}, props), {}, {
          relationship: relationship,
          onUpdate: options.onUpdate
        }))
      });
    }
  };
}